export default "__VITE_PUBLIC_ASSET__b72dbaa4__"